import React from 'react';
import PropTypes from 'prop-types';

const Anchor = (props) => (
  <a
    className="anchorTag"
    {...props}
  >
    {props.children}
  </a>
)

Anchor.propTypes = {
  children: PropTypes.any,
}

export default Anchor;